import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeLayoutModule } from './layouts/homelayout.module';
import { FormsModule } from '@angular/forms';
import { ServiceModule } from "./services/service.module";
import { PagesModule } from "./pages/pages.module";
import { BrowserModule } from '@angular/platform-browser';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { GlobalVariable } from './app.globalvariable'
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { MomentModule } from 'angular2-moment';
import { SafeHtmlPipe } from './pages/pipe/safe-html.pipe';
@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe
  ],
  imports: [
    AppRoutingModule,
    HomeLayoutModule,
    NoopAnimationsModule,
    FormsModule,
    ServiceModule,
    PagesModule,
    BrowserModule,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MomentModule,
    NgIdleKeepaliveModule.forRoot(),
  ],

  exports: [
    SafeHtmlPipe
  ],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }, SafeHtmlPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
